// extracted by mini-css-extract-plugin
export default {"block":"EditMore_block__eB9gy","blockLanguages":"EditMore_blockLanguages__yIsaf","title":"EditMore_title__zv+Hg"};